import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Website in progress - Please return at a later date
        </p>
        <a
          className="App-link"
          href="https://bananaslam.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Banana Slam
        </a>
      </header>
    </div>
  );
}

export default App;
